import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeProvider from './theme';
import { DarkThemeProvider } from './Context/ThemeContext';
// import * as serviceWorker from './serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<React.StrictMode> 
    <DarkThemeProvider>
        <ThemeProvider>
        <App />
        </ThemeProvider>
    </DarkThemeProvider>
</React.StrictMode>   

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// serviceWorker.register();